import React from 'react'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const LocationSummaryLoading = () => {
  const {isMobile} = useDeviceLayout()

  if (isMobile)
    return (
      <Box paddingTop="s300" paddingBottom="s300">
        <SkeletonLoader width={120} />
      </Box>
    )

  return (
    <Box paddingTop="s300">
      <SkeletonLoader width={307} />
    </Box>
  )
}
